import { TableRow, TableCell, Box } from '@mui/material';
import AccountSalesManageStaticTableCell from './AccountSalesManageStaticTableCell';

const AccountSalesMangageStaticsRow = ({ data, headers }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((comData, comIndex) => {
      return comData?.accounts?.map((account, aIndex) => {
        return (
          <TableRow key={`${comIndex}${aIndex}`}>
            {aIndex === 0 && (
              <TableCell sx={{ width: 120 }} rowSpan={comData?.rowSpan}>
                {comData?.companyNm}
              </TableCell>
            )}
            <TableCell align="center" sx={{ width: 200 }}>
              {account.label}
            </TableCell>
            <AccountSalesManageStaticTableCell
              data={account?.data}
              headerRows={headers}
            />
          </TableRow>
        );
      });
    })
  );
};

export default AccountSalesMangageStaticsRow;
